// extracted by mini-css-extract-plugin
export default {"actionsColumn":"OrderServiceDetails_actionsColumn__nT-xi"};